import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';

import type {
  CreateCustomFieldInput,
  CustomFieldDefinition,
  CustomFieldListFilter,
  UpdateCustomFieldInput,
} from '../types';

const CUSTOM_FIELDS_URL = '/custom-fields';

function buildCustomFieldsQuery(filters?: CustomFieldListFilter): string {
  const queryParams = new URLSearchParams();
  if (filters?.escritorioId) queryParams.append('escritorioId', filters.escritorioId);
  if (filters?.category) queryParams.append('category', filters.category);
  if (filters?.source) queryParams.append('source', filters.source);

  const query = queryParams.toString();
  return query ? `${CUSTOM_FIELDS_URL}?${query}` : CUSTOM_FIELDS_URL;
}

export const customFieldsApi = {
  async list(filters?: CustomFieldListFilter): Promise<CustomFieldDefinition[]> {
    const response = await apiGet(buildCustomFieldsQuery(filters));
    const allFields = await parseApiResponse<CustomFieldDefinition[]>(response);

    if (filters?.active !== undefined) {
      return allFields.filter((field) => field.active === filters.active);
    }

    return allFields;
  },

  async getById(id: string): Promise<CustomFieldDefinition> {
    const response = await apiGet(`${CUSTOM_FIELDS_URL}/${id}`);
    return parseApiResponse<CustomFieldDefinition>(response);
  },

  async create(data: CreateCustomFieldInput): Promise<CustomFieldDefinition> {
    const payload = {
      ...data,
      source: data.source ?? 'CUSTOM',
    };
    const response = await apiPost(CUSTOM_FIELDS_URL, payload);
    return parseApiResponse<CustomFieldDefinition>(response);
  },

  async update(id: string, data: UpdateCustomFieldInput): Promise<CustomFieldDefinition> {
    const response = await apiPut(`${CUSTOM_FIELDS_URL}/${id}`, data);
    return parseApiResponse<CustomFieldDefinition>(response);
  },

  async remove(id: string): Promise<void> {
    const response = await apiDelete(`${CUSTOM_FIELDS_URL}/${id}`);
    await parseApiResponse<void>(response, { allowNoContent: true });
  },
};
